import { CONTENT_ACTIONS } from '../../actions/content';

const initialState = {
  documents: [],
  types: [],
  contentTypeStack: [],
  routes: [],
  models: [],
  updated: false,
  isReadOnlyMode: false,
  calendarEvents: {},
  appThemes: [],
  screenDesignerMode: false,
  screenDesignerContent: undefined,
  customRouteMode: false,
  customRouteContent: undefined,
  scenario: undefined,
  codeEditorInsert: undefined,
  codeEditorInsertRequested: false
};

const ContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_ACTIONS.INSERT_CODE_EDITOR_CONTENT: {
      return {
        ...state,
        codeEditorInsert: action.payload
      };
    }
    case CONTENT_ACTIONS.CLEAR_CODE_EDITOR_INSERT: {
      return {
        ...state,
        codeEditorInsert: undefined,
        codeEditorInsertRequested: false
      };
    }
    case CONTENT_ACTIONS.CODE_INSERT_REQUESTED: {
      return {
        ...state,
        codeEditorInsertRequested: true
      };
    }
    case CONTENT_ACTIONS.DATA_SCENARIO_LOADED: {
      return {
        ...state,
        scenario: action.payload
      };
    }
    case CONTENT_ACTIONS.DATA_SCENARIO_CLEARED: {
      return {
        ...state,
        scenario: undefined
      };
    }
    case CONTENT_ACTIONS.SCREEN_DESIGNER_MODE: {
      return {
        ...state,
        screenDesignerMode: action.payload
      };
    }
    case CONTENT_ACTIONS.SCREEN_DESIGNER_CONTENT: {
      return {
        ...state,
        screenDesignerContent: action.payload
      };
    }
    case CONTENT_ACTIONS.CUSTOM_ROUTE_MODE: {
      return {
        ...state,
        customRouteMode: action.payload
      };
    }
    case CONTENT_ACTIONS.CUSTOM_ROUTE_CONTENT: {
      return {
        ...state,
        customRouteContent: action.payload
      };
    }
    case CONTENT_ACTIONS.APP_THEMES_LOADED: {
      return {
        ...state,
        appThemes: action.payload
      };
    }
    case CONTENT_ACTIONS.CALENDAR_EVENTS_LOADED: {
      return {
        ...state,
        calendarEvents: {
          ...state.calendarEvents,
          ...action.payload
        }
      };
    }
    case CONTENT_ACTIONS.CONTENT_MODELS_LOADED: {
      return {
        ...state,
        models: action.payload
      };
    }
    case CONTENT_ACTIONS.CONTENT_EDIT_MODE: {
      return {
        ...state,
        isReadOnlyMode: false
      };
    }
    case CONTENT_ACTIONS.CONTENT_READONLY_MODE: {
      return {
        ...state,
        isReadOnlyMode: true
      };
    }
    case 'CONTENT_TAB_SELECTED': {
      const newState = Object.assign({}, state);
      newState.documents[newState.documents.length - 1].tabIndex =
        action.payload;
      return newState;
    }

    case 'FORM_VALUES_CHANGED': {
      return {
        ...state,
        currentForm: action.payload
      };
    }
    case CONTENT_ACTIONS.CONTENT_TYPES_LOADED: {
      return {
        ...state,
        types: action.payload,
        updated: false
      };
    }
    case CONTENT_ACTIONS.CONTENT_TYPE_UPDATED: {
      const newTypes = [...state.types];
      const index = newTypes.findIndex(t => t.type === action.payload.type);
      newTypes[index] = action.payload;

      return {
        ...state,
        types: newTypes
      };
    }
    case CONTENT_ACTIONS.CONTENT_TYPES_UPDATED: {
      return {
        ...state,
        updated: true
      };
    }
    case 'RELATED_CONTENT_LOADED': {
      const newState = Object.assign({}, state);

      if (
        newState.documents[newState.documents.length - 1].type !==
        action.payload.type
      ) {
        if (!newState.documents[newState.documents.length - 1].relatedContent) {
          newState.documents[newState.documents.length - 1].relatedContent = {};
        }
        newState.documents[newState.documents.length - 1].relatedContent[
          action.payload.collection
        ] = action.payload;
      }

      return newState;
    }
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case 'DOCUMENT_DELETED': {
      const newState = Object.assign({}, state);
      const docIndex = newState.documents.findIndex(
        d => d.id === action.payload.id
      );
      if (docIndex > -1) {
        newState.documents.splice(docIndex, 1);
      }
      return newState;
    }

    default:
      if (
        action &&
        action.type &&
        action.type.indexOf('_INSTANCE_SELECTED') > -1
      ) {
        /*
            {
              payload: { type: 'something', id: 'of the record', document: optional }
            }
            If there is an existing doc of the same time, then remove it and any documents further down than it as they are child docs
            Then add in the newly selected document
          */
        const existingDocIndex = state.documents.findIndex(
          d => d.type === action.payload.type
        );

        const newState = Object.assign({}, state);

        if (existingDocIndex > -1) {
          newState.documents.splice(
            existingDocIndex,
            newState.documents.length - existingDocIndex
          );
        }

        newState.documents.push({
          id: action.payload.id,
          type: action.payload.type,
          tabIndex: action.payload.tabIndex
        });

        /* set the path of this document such as /courses/<id>/lessons/<id>/media/<this-document-id> */
        const pathSegments = newState.documents.map(doc => {
          return `${
            state.types.find(t => t.type === doc.type).collectionName
          }/${doc.id}`;
        });

        const contentTypeStackIndex = newState.contentTypeStack.findIndex(
          t => t === action.payload.type
        );

        if (contentTypeStackIndex === -1) {
          newState.contentTypeStack.push(action.payload.type);
        } else if (
          action.payload.type !==
          newState.contentTypeStack[newState.contentTypeStack.length - 1]
        ) {
          /* Removing .. going back up a breadcrumn */
          newState.contentTypeStack.splice(
            contentTypeStackIndex + 1,
            newState.contentTypeStack.length - contentTypeStackIndex
          );
        }

        const collectionSegments = newState.contentTypeStack.map(
          (contentTypeName, index) => {
            if (index < newState.documents.length - 1) {
              return `${
                state.types.find(t => t.type === contentTypeName).collectionName
              }/${newState.documents[index].id}`;
            }
            return state.types.find(t => t.type === contentTypeName)
              .collectionName;
          }
        );

        const theType = state.types.find(t => t.type === action.payload.type);

        if (theType.hasOwnCollection) {
          newState.documents[newState.documents.length - 1].paths = {
            document: `${theType.collectionName}/${
              newState.documents[newState.documents.length - 1].id
            }`,
            collection: theType.collectionName
          };
        } else {
          newState.documents[newState.documents.length - 1].paths = {
            document: pathSegments.join('/'),
            collection: collectionSegments.join('/')
          };
        }

        if (action.payload.document) {
          newState.documents[newState.documents.length - 1].data =
            action.payload.document;
          if (theType.list.directoryListItemLayout.breadcrumbFieldName) {
            newState.documents[newState.documents.length - 1].breadcrumb =
              action.payload.document[
                theType.list.directoryListItemLayout.breadcrumbFieldName
              ];
          } else if (action.payload.document.breadcrumb) {
            newState.documents[newState.documents.length - 1].breadcrumb =
              action.payload.document.breadcrumb;
          }
        } else if (action.payload.breadcrumb) {
          newState.documents[newState.documents.length - 1].breadcrumb =
            action.payload.breadcrumb;
        }

        if (action.payload.mediaLibrary) {
          newState.documents[newState.documents.length - 1].mediaLibrary =
            action.payload.mediaLibrary;
        }

        return newState;
      }
      return state;
  }
};

export default ContentReducer;
